import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CoinPercent({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M11.7902 9.2L15.2002 5.78M11.5702 5.65C11.5702 5.6 11.6002 5.559 11.6502 5.559C11.6902 5.559 11.7302 5.589 11.7302 5.639C11.7202 5.679 11.6902 5.719 11.6402 5.719C11.5902 5.709 11.5502 5.679 11.5502 5.629V5.619M8.00023 7V5.3C8.00023 3.47 9.47023 2 11.3002 2H15.7002C17.5202 2 19.0002 3.47 19.0002 5.3V9.7C19.0002 11.52 17.5202 13 15.7002 13H15.0002M15.4252 9.34C15.4152 9.38 15.3852 9.42 15.3352 9.42C15.2852 9.41 15.2452 9.38 15.2452 9.33C15.2452 9.28 15.2752 9.24 15.3252 9.24C15.3652 9.24 15.4052 9.27 15.4052 9.32M3.00023 12.6V19.4C3.00023 20.28 4.79023 21 7.00023 21C9.20023 21 10.9902 20.28 11.0002 19.4V12.6M3.00023 16C3.00023 16.88 4.78023 17.6 6.99023 17.6C9.19023 17.6 10.9902 16.88 10.9902 16M10.9902 12.6C10.9902 13.48 9.19023 14.2 6.99023 14.2C4.78023 14.2 2.99023 13.48 2.99023 12.6C2.99023 11.71 4.78023 11 6.99023 11C9.19823 11 10.9802 11.71 10.9902 12.6Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default CoinPercent;